import { useCallback, useEffect, useState } from "react";
import useNotificationMessageService from "../../../hooks/useNotificationMessageService";
import ThemedModal from "../../../@ui/Modal/ThemedModal";
import { Button, Modal } from "react-bootstrap";
import { UserNotification } from "../../../types/Notification";
import LoadingSpinner from "../../Loading/LoadingSpinner";
import { Pagination } from "../../../types/PaginiationResult";
import UserNotificationTable from "./UserNotificationTable";

interface UserNotificationModalProps {
    show: boolean;
    onClose: () => void;
    totalUnreadCount: number;
    markRead: (ids: string[]) => void;
}

const UserNotificationModal = ({ show, onClose, totalUnreadCount, markRead }: UserNotificationModalProps) => {
    const notificationMessageService = useNotificationMessageService();
    const [loading, setLoading] = useState(true);
    const [notifications, setNotifications] = useState<Pagination<UserNotification>>({
        records: [],
        page: 1,
        totalPages: 1,
    });
    const [apiErrorMessage, setApiErrorMessage] = useState<string | null>(null);


const fetchNotifications = useCallback(
  async (page?: number) => {
    setLoading(true);
    setApiErrorMessage(null); // reset any previous error message
    try {
      const result = await notificationMessageService.getUserNotifications(page);

      const appendedPage = {
        ...result,
        records: [...notifications.records, ...result.records],
      };

      setNotifications(appendedPage);
    } catch (error: any) {
      setApiErrorMessage(
        "Failed to fetch notifications. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  },
  [notificationMessageService, notifications.records]
);

    useEffect(() => {
        fetchNotifications();
    }, []);


    const markAsRead = useCallback(() => {
      markRead(notifications.records.filter(n => !n.isRead).map(n => n.notificationId));  
    }, [notifications]);


    return(<ThemedModal size="lg" centered show={show} onHide={onClose}>
            <Modal.Header>
              <Modal.Title>
              Notifications
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {apiErrorMessage && (
                <div className="p-1 bg-danger text-white mb-2">
                  {apiErrorMessage}
                </div>
              )}

              {loading ? (
                <LoadingSpinner />
                ) : 
                <UserNotificationTable 
                page={notifications} 
                onPageChange={fetchNotifications} 
                totalUnreadCount={totalUnreadCount} 
                pageSize={10} 
                /> 
                }

            </Modal.Body>
            <Modal.Footer>
              <Button
                className="text-white"
                variant="secondary"
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button onClick={() => markAsRead()} className="text-white" >
                OK
              </Button>
            </Modal.Footer>
    </ThemedModal>
    );
};
export default UserNotificationModal;